export enum QuizStep {
  INITIAL = 1,
  FAILED = 2,
  COMPLETED = 3,
}
